<template>
  <q-select
    v-model="value_"
    :multiple="multiple"
    filterable
    :disabled="disabled"
    :placeholder="placeholder"
  >
    <q-option label="" :value="null" />
    <q-option
      v-for="item in items"
      :key="item[valueField]"
      :label="item[displayField]"
      :value="item[valueField]"
    />
  </q-select>
</template>

<script>
export default {
  name: "QModelSelector",

  props: {
    value: {
      required: true,
    },

    disabled: { type: Boolean, default: false },
    placeholder: { default: "", type: String },
    plugin: { required: true, type: String },
    delegate: { required: true, type: String },
    displayField: { default: "caption", type: String },
    valueField: { default: "id", type: String },
    multiple: { type: Boolean, default: false },
  },

  data() {
    return {
      value_: {},
      items: [],
    };
  },

  watch: {
    value_() {
      this.$emit("input", this.value_);
    },
    value() {
      this.value_ = this.value;
    },
  },
  created() {
    this.value_ = this.value;
  },

  mounted() {
    this.fetchItems();
  },

  methods: {
    fetchItems() {
      this.$delegate(this.plugin, this.delegate, {})
        .then((res) => {
          this.items = res.result.models;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped></style>
